import { useCallback } from 'react';
import { useQueryClient } from '@common-fe/common-fe';

import { QUERY_KEY } from '@/modules/transaction/hooks/useMyEnrollments';

export default () => {
  const queryClient = useQueryClient();
  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEY],
    });
  }, [queryClient]);

  return {
    invalidateQuery,
  };
};
